import { Controller } from "@hotwired/stimulus"

// Multi-select on the Single Generations dashboard. Tracks which result
// cards are checked, surfaces a floating "Download N as ZIP" button when
// the selection is non-empty, and on submit injects one hidden ids[] input
// per selected card into the form before posting.
export default class extends Controller {
  static targets = ["checkbox", "bar", "count", "form", "hiddenInputs"]

  connect() {
    this.refresh()
  }

  // Fired on individual checkbox change AND on the parent card click (when
  // we want clicking the card body to also toggle the box). Just refresh.
  toggle(_event) {
    this.refresh()
  }

  // Toggle by clicking anywhere on the card surface, except interactive
  // children (links / buttons / the existing show-page navigation).
  toggleFromCard(event) {
    if (event.target.closest("a, button, input")) return
    const cb = event.currentTarget.querySelector("[data-single-generation-selection-target='checkbox']")
    if (!cb || cb.disabled) return
    cb.checked = !cb.checked
    this.refresh()
  }

  clear(event) {
    if (event) event.preventDefault()
    this.checkboxTargets.forEach((cb) => { cb.checked = false })
    this.refresh()
  }

  submit(event) {
    const selected = this.checkboxTargets.filter((cb) => cb.checked)
    if (selected.length === 0) {
      event.preventDefault()
      return
    }
    if (!this.hasHiddenInputsTarget) return

    this.hiddenInputsTarget.innerHTML = ""
    selected.forEach((cb) => {
      const input = document.createElement("input")
      input.type  = "hidden"
      input.name  = "ids[]"
      input.value = cb.dataset.recordId
      this.hiddenInputsTarget.appendChild(input)
    })
  }

  // --- helpers ---

  refresh() {
    const count = this.checkboxTargets.filter((cb) => cb.checked).length
    if (this.hasCountTarget) this.countTarget.textContent = count
    if (this.hasBarTarget) this.barTarget.hidden = count === 0
  }
}
